"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pause = void 0;
/**
 * Function used in async/await to pause execution for a set number of milliseconds.
 * Note, the number of milliseconds in a minimum, not a guarantee.
 */
const pause = (milliseconds) => new Promise((resolve) => {
    setTimeout(() => resolve(), milliseconds);
});
exports.pause = pause;
